export const SMART_FIELD_CLASSNAME = 'hb-smart-value';

export const COMMERCIAL_EMAIL_MARKER_CLASS_NAME = 'commercial-email-marker';

export const COMMERCIAL_EMAIL_MARKER_TEXT = `<div class=${COMMERCIAL_EMAIL_MARKER_CLASS_NAME}>&nbsp;</div>`;

export const ONE_COMPOSER_TEST_IDS = {
    addSmartField: 'add-smart-field',
    addRemoveLogo: 'add-remove-logo',
    addSignature: 'add-remove-signature',
    addReferralLink: 'add-referral-link',
    commercialEmailToggle: 'commercial-email-toggle',
    ctaEditPopover: 'cta-edit-popover',
    editCtaText: 'edit-cta-text',
    emailPreview: 'preview-button',
    moreOptions: 'more-options'
};

export const ONE_COMPOSER_SIGNATURE_PLACEHOLDER_HTML =
    '<div class="editor-email-signature ck-content email-signature-placeholder" name="EmailSignature">&nbsp;</div>';

export const SUBJECT_ROW_HEIGHT = 55;
